import React, { useState, useEffect } from "react";
import { DragAndDrop, Drag, Drop } from "../drag-and-drop";
// import { reorder } from "./helpers.js";
import { DragDropMajor, PlusCircleIcon } from "@shopify/polaris-icons";
import { Button, ButtonGroup } from "@shopify/polaris";
const MenusDraggableNestedList = (props) => {
  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };
  const [categories, setCategories] = useState([]);
  useEffect(() => {
    console.log("ppppp=", props.items);
    setCategories(props.items);
  }, [props]);

  const handleDragEnd = (result) => {
    const { type, source, destination } = result;
    if (!destination) return;
    console.log("source=", source);
    console.log("destination=", destination);
    const sourceCategoryId = source.droppableId;
    const destinationCategoryId = destination.droppableId;
    console.log("sourceCategoryId=", sourceCategoryId);
    console.log("destinationCategoryId=", destinationCategoryId);
    // Reordering items
    if (type === "droppable-item") {
      // If drag and dropping within the same category

      //CASE 1 : DRAG CHILDS IN SAME PARENT
      if (sourceCategoryId === destinationCategoryId) {
        const updatedOrder = reorder(
          categories.find((category) => category.id === sourceCategoryId).items,
          source.index,
          destination.index
        );
        const updatedCategories = categories.map((category) =>
          category.id !== sourceCategoryId
            ? category
            : { ...category, items: updatedOrder }
        );
        console.log("updatedCategories1=", updatedOrder);
        props.handleUpdateOrder(updatedOrder, "childs", "dagChildInSameParent");
        setCategories(updatedCategories);
      }
      //CASE 2 : DRAG CHILDS TO DIFFERENT PARENT
      else {
        const sourceOrder = categories.find(
          (category) => category.id === sourceCategoryId
        ).items;
        const destinationOrder = categories.find(
          (category) => category.id === destinationCategoryId
        ).items;

        const [removed] = sourceOrder.splice(source.index, 1);
        destinationOrder.splice(destination.index, 0, removed);

        destinationOrder[removed] = sourceOrder[removed];
        delete sourceOrder[removed];
        console.log("destinationOrder=", destinationOrder);

        const updatedCategories = categories.map((category) =>
          category.id === sourceCategoryId
            ? { ...category, items: sourceOrder }
            : category.id === destinationCategoryId
            ? { ...category, items: destinationOrder }
            : category
        );
        console.log("updatedCategories2=", updatedCategories);
        props.handleUpdateOrder(
          updatedCategories,
          "childs",
          "dagChildToAnotherParent"
        );
        setCategories(updatedCategories);
      }
    }

    // Reordering categories
    //CASE 3 : DRAG PARENTS
    if (type === "droppable-category") {
      const updatedCategories = reorder(
        categories,
        source.index,
        destination.index
      );
      console.log("updatedCategories3=", updatedCategories);
      props.handleUpdateOrder(updatedCategories, "parents", "dragParents");
      setCategories(updatedCategories);
    }
  };

  return (
    <DragAndDrop onDragEnd={handleDragEnd}>
      <Drop id="droppable" type="droppable-category">
        {categories.map((category, categoryIndex) => {
          return (
            <Drag
              className="draggable-category"
              key={category.id}
              id={category.id}
              index={categoryIndex}
            >
              <div className="category-container">
                <div className="rowDiv">
                  <h2 className="item">
                    {category.image && (
                      <img
                        src={category.image}
                        width={20}
                        style={{ marginRight: "0.7rem" }}
                      />
                    )}
                    {category.name}
                    <div style={{ float: "right" }}>
                      <ButtonGroup>
                        <Button
                          size="slim"
                          onClick={() =>
                            props.handleEditMenuItem(
                              category.element,
                              category.id,
                              "parent"
                            )
                          }
                          // onClick={() => console.log(category.element)}
                        >
                          Edit
                        </Button>
                        <Button
                          size="slim"
                          onClick={() => props.handleDeleteItem(category.id)}
                        >
                          Delete
                        </Button>
                      </ButtonGroup>
                    </div>
                  </h2>
                </div>

                <Drop key={category.id} id={category.id} type="droppable-item">
                  {category.items.map((item, index) => {
                    return (
                      <Drag
                        className="draggable"
                        key={item.id}
                        id={item.id}
                        index={index}
                      >
                        <div className="rowDiv" style={{ width: "100%" }}>
                          <div className="item">
                            {item.image && (
                              <img
                                src={item.image}
                                width={20}
                                style={{ marginRight: "0.7rem" }}
                              />
                            )}
                            {item.name}
                            <div style={{ float: "right" }}>
                              <ButtonGroup>
                                <Button
                                  size="slim"
                                  onClick={() =>
                                    props.handleEditMenuItem(
                                      item.element,
                                      item.id,
                                      `child_${item.id}`
                                    )
                                  }
                                >
                                  Edit
                                </Button>
                                <Button
                                  size="slim"
                                  onClick={() =>
                                    props.handleDeleteItem(item.id)
                                  }
                                >
                                  Delete
                                </Button>
                              </ButtonGroup>
                            </div>
                          </div>
                        </div>
                      </Drag>
                    );
                  })}
                </Drop>
                <div className="mt-3">
                  <Button
                    fullWidth
                    icon={PlusCircleIcon}
                    plain
                    onClick={() => props.handleAddSubitem(category.id)}
                  >
                    Add subitem
                  </Button>
                </div>
              </div>
            </Drag>
          );
        })}
      </Drop>
    </DragAndDrop>
  );
};
export default MenusDraggableNestedList;
